/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type PatientDtoResidencyPermit = (typeof PatientDtoResidencyPermit)[keyof typeof PatientDtoResidencyPermit];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientDtoResidencyPermit = {
  UNKNOWN: 'UNKNOWN',
  NONE: 'NONE',
  L_SHORT_RESIDENCE: 'L_SHORT_RESIDENCE',
  F_TEMPORARY: 'F_TEMPORARY',
  N_ASYLUM: 'N_ASYLUM',
  S_PROTECTED: 'S_PROTECTED',
  B_RESIDENCE: 'B_RESIDENCE',
  C_SETTLEMENT: 'C_SETTLEMENT',
  CI_RESIDENCE_WORKING: 'CI_RESIDENCE_WORKING',
  G_BORDER: 'G_BORDER',
  TOURIST: 'TOURIST',
  NATURALIZED_CITIZEN: 'NATURALIZED_CITIZEN',
  SWISS_BORN: 'SWISS_BORN',
} as const;
